import { notificationApi } from '../api/notificationApi';

// VAPID Public Key (öffentlich und sicher im Frontend)
const VAPID_PUBLIC_KEY = 'BG5Tmx3uQQMUZJKzXAu8GYOHY-zlUeq60DW0OdnTc-VVWLziAlhP5WCfd33PFWhQeNHOepPpxsvLXhtDFm7fcyk';

// Check if Push Notifications are supported
export function isPushSupported() {
  const hasServiceWorker = 'serviceWorker' in navigator;
  const hasPushManager = 'PushManager' in window;
  const hasNotification = 'Notification' in window;

  console.log('[Push] Support check:', {
    serviceWorker: hasServiceWorker,
    pushManager: hasPushManager,
    notification: hasNotification,
    isStandalone: isStandalonePWA(),
    userAgent: navigator.userAgent.substring(0, 50)
  });

  return hasServiceWorker && hasPushManager && hasNotification;
}

// Check if running as standalone PWA (added to home screen)
export function isStandalonePWA() {
  // iOS Safari standalone mode
  if (window.navigator.standalone === true) {
    return true;
  }
  // Other browsers (Chrome, etc.)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  return false;
}

// Check current permission
export function getPermissionStatus() {
  if (!isPushSupported()) return 'unsupported';
  return Notification.permission;
}

// Request Push Permission
export async function requestPushPermission() {
  if (!isPushSupported()) {
    throw new Error('Push Notifications werden nicht unterstützt');
  }

  const permission = await Notification.requestPermission();
  return permission;
}

// Subscribe to Push Notifications
export async function subscribeToPush() {
  try {
    // Check support
    if (!isPushSupported()) {
      throw new Error('Push Notifications werden nicht unterstützt');
    }

    // Use static VAPID key (public key is safe to embed)
    const vapidPublicKey = VAPID_PUBLIC_KEY;

    // Get service worker registration
    const registration = await navigator.serviceWorker.ready;

    // Check if already subscribed
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      // Convert VAPID key
      const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

      // Subscribe
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey
      });
    }

    // Send subscription to backend
    const deviceInfo = {
      deviceType: getMobileOperatingSystem(),
      deviceName: getBrowserName()
    };

    await notificationApi.subscribePush(subscription, deviceInfo);

    console.log('Push Notifications aktiviert');
    return subscription;

  } catch (error) {
    console.error('Push subscription error:', error);
    throw error;
  }
}

// Unsubscribe from Push
export async function unsubscribeFromPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      await subscription.unsubscribe();
      await notificationApi.unsubscribePush(subscription.endpoint);
      console.log('Push Notifications deaktiviert');
    }
  } catch (error) {
    console.error('Push unsubscribe error:', error);
    throw error;
  }
}

// Helper: Convert VAPID key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Helper: Detect device type
function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return "mobile";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "mobile";
  }

  return "desktop";
}

// Helper: Get browser name
function getBrowserName() {
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } else if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (userAgent.indexOf("Edge") > -1) {
    return "Edge";
  }
  return "Browser";
}
